
export interface DispatchBoardQueueLoad {
    picklistNumber: number;
    manifestNumber: number;
    status: DispatchBoardQueueStatus;
    routeName: string;
    door: string;
    trailerNumber: string;
    tractorNumber: string;
    driverNumber: number;
    carrierNumber: number;
    stops: number;
    probills: number;
    pieces: number;
    weight: number;
    loadedProbills: number;
    loadedPieces: number;
    loadedWeight: number;
    deliveredProbills: number;
    deliveredPieces: number;
    deliveredWeight: number;
    plannedDispatchedAt: Date;
    dispatchedAt: Date;
    earliestEta: Date;
    latestEta: Date;
    driverName: string;
    carrierName: string;
}

export enum DispatchBoardQueueStatus {
    READY_TO_ASSIGN = "READY_TO_ASSIGN",
    LOADING = "LOADING",
    READY_TO_CLOSE = "READY_TO_CLOSE",
    READY_TO_DISPATCH = "READY_TO_DISPATCH",
    DISPATCHED = "DISPATCHED"
}

export interface GetDispatchBoardQueueRequest {
    terminalNumber: number | undefined;
}

export interface GetDispatchBoardQueueResponse {
    loads: DispatchBoardQueueLoad[];
}